import DemoLandingTemplate from '../../components/marketing/DemoLandingTemplate';
import type { DemoConfig } from '../../components/marketing/DemoLandingTemplate';

/* Demo landing page for Jerry Dent at Alvarez & Marsal. Draws on the verified
   A&M research (see project_alvarez_marsal_partnership): honest fit is
   FL/HMDA/CRA/marketing + AI governance execution layer — NOT BSA/AML (that's
   A&M's expertise; only a forward-looking roadmap allusion, NDA-safe, no names).
   Companion to the full proposal at /partners/alvarez-marsal. */
const config: DemoConfig = {
  docTitle: 'Alvarez & Marsal × Clarid — Demo',
  company: 'Alvarez & Marsal',
  firstName: 'Jerry',
  eyebrow: 'Prepared for your Clarid demo',
  headline: 'The execution layer for the compliance advice A&M already gives',
  lead: "Clarid is an AI-native compliance platform for community banks — the productized, examiner-grade layer that turns Alvarez & Marsal's advisory into continuous execution. Here's what we'll walk through together.",
  fitHeadline: 'Where Clarid fits Alvarez & Marsal',
  fitParagraphs: [
    'A&M has made one of the most aggressive AI commitments in professional services — an AI Governance practice, a Global AI Board, and a public goal of drawing roughly half its revenue from AI by 2028 — alongside deep community-bank credibility (former bank regulators on staff) advising these institutions on fair lending, HMDA, and CRA.',
    'What A&M publishes a point of view on — AI governance and modern compliance for community banks — still has no productized, examiner-grade delivery layer behind it. Clarid is that layer: a live platform mapped to the Treasury’s FS AI RMF, covering fair lending, HMDA, CRA, marketing, and exam packaging.',
    'A&M sets the standard; Clarid is the governed system that sustains it after the engagement ends — at a scale community banks can actually afford.',
  ],
  agendaHeadline: "What we'll cover",
  agenda: [
    { title: 'A short platform tour', body: 'Fair lending, HMDA, CRA, and marketing compliance in one connected system — and how findings assemble into a single examiner-ready package and board summary.' },
    { title: 'AI governance, made concrete', body: 'Clarid mapped to the FS AI RMF — human-in-the-loop, hash-chained audit trail, model validation and bias testing. A working, inspectable reference implementation of governed AI for the narrative A&M is building.' },
    { title: 'Where Clarid fits your practice', body: 'The execution layer for A&M’s community-bank consumer-compliance advisory, and the continuous-monitoring layer after a remediation. (BSA/AML is a deliberate next chapter on our roadmap — an area where A&M’s strength is directly relevant.)' },
    { title: 'Partnership models', body: 'Referral, co-sell, or embedded-in-engagement — which shape best fits A&M’s client strategy and partner framework.' },
  ],
  contact: {
    name: 'Bobby Sloan',
    title: 'Founder & CEO, Clarid',
    email: 'bobby@clarid.ai',
  },
};

export default function DentDemoPage() {
  return <DemoLandingTemplate config={config} />;
}
